/*
 * @Author: chi.yong chi.yong@jitai.ai
 * @Date: 2024-05-10 14:39:15
 * @LastEditors: chi.yong chi.yong@jitai.ai
 * @LastEditTime: 2025-03-12 17:25:02
 * @FilePath: /JTFEE_open_api_platform/src/router/index.ts
 * @Description: router setting
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { createRouter, createWebHistory } from 'vue-router';

import { useUserStore } from '@/stores/userStore.ts';

const isLoading = ref(false);

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_PATH),
  routes: [
    // 捕获所有未知路由并重定向到首页
    {
      path: '/:catchAll(.*)',
      redirect: '/usage'
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/login/RegisterPage.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/LoginPage.vue')
    },
    {
      path: '/forgetPass',
      name: 'forgetPass',
      component: () => import('@/views/login/ForgetPass.vue')
    },
    {
      path: '/index',
      name: 'home',
      component: () => import('@/views/HomeView.vue'),
      children: [
        {
          path: '/account',
          name: 'account',
          component: () => import('@/views/account/Account.vue')
        },
        {
          path: '/keys',
          name: 'keys',
          component: () => import('@/views/account/ApiKeys.vue')
        },
        {
          path: '/usage',
          name: 'usage',
          component: () => import('@/views/account/Usage.vue')
        },
        {
          path: '/recharge',
          name: 'recharge',
          component: () => import('@/views/account/Recharge.vue')
        }
      ]
    }
  ]
});

router.beforeEach((to, from) => {
  isLoading.value = true; // 开始加载
  const userStore = useUserStore();
  const isToken = userStore.userInfo.Authorization;
  const apply_status = userStore.userInfo.apply_status;
  if (to.path === '/') {
    return '/usage';
  }
  if (to.path === '/index') {
    // 跳转到官网
    window.location.replace('http://www.jitai.info');
  }
  if (
    !isToken &&
    to.path !== '/login' &&
    to.path !== '/register' &&
    to.path !== '/forgetPass' &&
    to.path !== '/productManual' &&
    to.path !== '/show' &&
    to.path !== '/pricing'
  ) {
    // 如果没有token,只能登录、注册、忘记密码
    ElMessage({
      message: `无权访问，请登陆`,
      type: 'error'
    });
    return '/login';
  }

  // 如果已经登录，申请状态是0、1、4，只能去首页、个人信息、申请、登录。
  if (
    isToken &&
    (apply_status === 1 || apply_status === 4) &&
    to.path !== '/account' &&
    to.path !== '/productManual' &&
    to.path !== '/show' &&
    to.path !== '/login' &&
    to.path !== '/index' &&
    to.path !== '/pricing'
  ) {
    return '/usage';
  }
});

router.afterEach(() => {
  isLoading.value = false; // 结束加载
  // 每次路由切换后重置滚动位置
  window.scrollTo(0, 0);
});
export { isLoading };
export default router;
